<template>
  <div class="query-page">
    <div class="container">
      <div class="left-panel">
        <h2>全日制<span class="highlight">自考</span></h2>
        <p>官方录取信息查询</p>
        <img style="height: 20px; margin-bottom: 57px; margin-top: 17px"
          src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x44.png" alt="education book" />
        <div class="image-box">
          <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x43.png" alt="education book" />
        </div>
      </div>
      <div class="right-panel">
        <h3>全日制自考官方录取查询</h3>
        <el-form :model="form" @submit.native.prevent="submitForm">
          <el-form-item label="" prop="name">
            <el-input v-model="form.name" placeholder="请输入姓名" clearable>
              <template #prefix>
                <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x45.png" alt="icon"
                  style="width: 16px; height: 16px; margin-right: 8px" />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="idNumber">
            <el-input v-model="form.idNumber" placeholder="请输入身份证号" clearable>
              <template #prefix>
                <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x46.png" alt="icon"
                  style="width: 16px; height: 16px; margin-right: 8px" />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="captcha">
            <div class="captcha-group">
              <el-input v-model="form.captcha" placeholder="请输入验证码" clearable>
                <template #prefix>
                  <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x47.png" alt="icon"
                    style="width: 16px; height: 16px; margin-right: 8px;margin-left:0 ;border-radius: 0;" />
                </template>
              </el-input>
              <img :src="codeImg" alt="验证码" @click="codeObjs" title="点击刷新验证码" />
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" native-type="submit" class="submit-btn">立即提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { codeObj } from "@/api/register";
import { TeacherClient } from '@/api/teacherClient.js'
import { getSurfaceList, } from "@/api/home";
let teacherClient = new TeacherClient()
export default {
  data() {
    return {
      codeKey: "",
      codeImg: "",
      form: {
        name: "",
        idNumber: "",
        captcha: "",
      },
    };
  },
  created() {
    this.codeObjs();
  },
  methods: {
    codeObjs() {
      codeObj().then((res) => {
        this.codeImg = res.data.img;
        this.codeKey = res.data.key;
      });
    },
    submitForm() {
      if (!this.form.name || !this.form.idNumber || !this.form.captcha) {
        this.$message.error("请填写完整信息");
        return;
      }

      teacherClient.selectSignUpInfoByNameAndIdNumber({
        name: this.form.name,
        idNumber: this.form.idNumber,
        captcha: this.form.captcha,
        codeKey: this.codeKey

      }).then((res) => {
        if (res.code == 0) {
          this.$router.push({
            path: '/cxReturn',
            query: {
              name: this.form.name,
              idNumber: this.form.idNumber,
              signUpInfo: JSON.stringify(res.data)
            }
          })
        } else {
          this.$message.error(res.msg);
        }
      })

      // 这里调用查询接口，示例用alert代替
      //       this.$message.success(`查询信息：
      // 姓名：${this.form.name}
      // 身份证号：${this.form.idNumber}
      // 验证码：${this.form.captcha}`);
      //       // 提交后刷新验证码
      //       this.codeObjs();
    },
  },
};
</script>

<style lang="less" scoped>
.query-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 792px;
  background: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x42.png");
  background-size: 100% 100%;

  .container {
    display: flex;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;

    .left-panel {
      font-family: Source Han Sans SC, Source Han Sans SC;
      font-weight: bold;
      font-size: 50px;
      line-height: 70px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      color: #1e2224;

      h2 {
        font-family: Source Han Sans SC, Source Han Sans SC;
        font-weight: bold;
        font-size: 50px;
        color: #1e2224;

        line-height: 70px;

        .highlight {
          color: #3a83fc;
        }
      }

      p {
        margin: 5px 0;
      }

      .image-box {
        img {
          width: 528px;
          object-fit: contain;
        }
      }
    }

    .right-panel {
      width: 521px;
      height: 522px;
      background: #ffffff;
      box-shadow: 0px 0px 20px 1px rgba(204, 204, 204, 0.34);
      border-radius: 24px 24px 24px 24px;
      padding: 60px;
      padding-top: 70px;

      h3 {
        font-family: Source Han Sans SC, Source Han Sans SC;
        font-weight: 500;
        font-size: 26px;
        color: #333333;
        line-height: 36px;
        text-align: center;
        margin-bottom: 50px;
      }

      /deep/ .el-input {
        width: 398px;
        height: 51px;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #eeeeee;
      }

      /deep/ .el-form-item__label {
        font-weight: 600;
        color: #555;
      }

      /deep/ .el-input__inner {
        width: 398px;
        height: 51px;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #eeeeee;
        padding-left: 49px;
      }

      .captcha-group {
        display: flex;
        align-items: center;

        /deep/ .el-input {
          width: 272px;
          height: 51px;
          background: #ffffff;
          border-radius: 8px 8px 8px 8px;
          border: 1px solid #eeeeee;
        }

        /deep/ .el-input__inner {
          width: 272px;
          height: 51px;
          background: #ffffff;
          border-radius: 8px 8px 8px 8px;
          border: 1px solid #eeeeee;
        }

        img {
          margin-left: 15px;
          width: 118px;
          height: 51px;
          border-radius: 8px 8px 8px 8px;
          cursor: pointer;
        }
      }

      .submit-btn {
        width: 398px;
        height: 51px;
        background: linear-gradient(90deg, #509fff 0%, #086aeb 100%);
        box-shadow: 0px 3px 20px 1px rgba(69, 151, 252, 0.6);
        border-radius: 8px 8px 8px 8px;
        margin: 0 auto;
        margin-top: 30px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        color: #ffffff;
        text-align: center;
      }
    }
  }
}

/deep/ .el-input__prefix {
  display: flex;
  align-items: center;
  margin-left: 18px;
}
</style>
